import { themesDispatches } from 'pages/appearance/containers/appearanceContainer/constants';
import { themesService } from 'services';
import { messageNotification, validateLoginSession, getWordpressBaseUrl } from 'helpers';

const fetchThemes = () => {
  return (dispatch) => {
    themesService
      .fetchThemes()
      .then((themes) => {
        dispatch(themesDispatches.fetchThemesSuccess(themes));
      })
      .catch((error) => {
        validateLoginSession(dispatch, error);
        dispatch(themesDispatches.fetchThemesFailure(error));
        if (error.response) {
          messageNotification('danger', 'There was an error fetching site themes', error.response);
        }
      });
  };
};

const updateThemeConfiguration = (payload) => {
  return (dispatch) => {
    themesService
      .updateSiteThemeConfiguration(payload)
      .then((response) => {
        if (getWordpressBaseUrl()) {
          dispatch(updateWordpressTheme(payload));
        }

        Promise.resolve(dispatch(updateLMSTheme(payload))).then(() => {
          messageNotification('success', '', 'Theme Updated Successfully');
        });
      })
      .catch((error) => {
        validateLoginSession(dispatch, error);
        if (error.response) {
          messageNotification('danger', 'There was an error updating site theme', error.response);
        }
      });
  };
};

const updateLMSTheme = (payload) => {
  return (dispatch) => {
    themesService
      .updateLMSTheme(payload)
      .then((response) => {
        dispatch(fetchThemes());
      })
      .catch((error) => {
        validateLoginSession(dispatch, error);
        if (error.response) {
          messageNotification('danger', 'There was an error updating theme', error.response);
        }
      });
  };
};

const updateWordpressTheme = (payload) => {
  return (dispatch) => {
    themesService.updateWordpressTheme(payload).catch((error) => {
      if (error.response) {
        messageNotification('danger', 'There was an error updating WordPress theme', error.response.data.message);
      }
    });
  };
};

export const themesActions = {
  fetchThemes,
  updateLMSTheme,
  updateThemeConfiguration
};
